import React from 'react';
import { Col, Row } from 'reactstrap';
import { showFailure } from '../../../../common/toast';
import { renderHTMLContent } from '../../../../common/function';

function ViewCase(props) {
  const {
    getPreviousCase,
    getNextCase,
    case_name,
    cases,
    disableNavigationButtons,
    casesData,
    caseIndex,
  } = props;
  return (
    <Row>
      <Col>
        <div className='note-section note-section-new view_questionhtml'>
          {case_name ? (
            <div className='card note-section-header px-0'>
              <div className='card-header title-font-size'>
              {renderHTMLContent(case_name, "span")}
                <div className='float-right text-right'>
                  <i
                    className={`fa fa-angle-left ${parseInt(caseIndex, 10) !== 0 ? 'ques_arrow' : 'ques_arrow_disable'
                      } pointer_class`}
                    onClick={() =>
                      !disableNavigationButtons
                        ? getPreviousCase()
                        : showFailure('Please select grading before proceeding to previous case')
                    }
                  // disabled={disableNavigationButtons}
                  />
                  <i
                    className={`fa fa-angle-right ${parseInt(caseIndex, 10) + 1 !== casesData.length
                      ? 'ques_arrow'
                      : 'ques_arrow_disable'
                      } pointer_class`}
                    onClick={() =>
                      !disableNavigationButtons
                        ? getNextCase()
                        : showFailure('Please select grading before proceeding to next case')
                    }
                  // disabled={disableNavigationButtons}
                  />
                </div>
              </div>
              <div className={'card-block note_text_wrap mt-1 mb-1'}>
                <div className='px-2'>
                {renderHTMLContent(cases, "span", "", { contentEditable: "false", suppressContentEditableWarning: true })}
                </div>
              </div>
            </div>
          ) : (
            <h4 className='card note-section-header text-center'>No case found</h4>
          )}
        </div>
      </Col>
    </Row>
  );
}

export default ViewCase;



// WEBPACK FOOTER //
// ./src/views/CFA3/Cfa3EssayQuestions/Layout/ViewCase.jsx